import React from "react";
import {getIsCroft} from "../../utils/croft";

export default () => {
    const isCroft = getIsCroft();
    
    return <span>{isCroft ? "01264 882222" : "01264 882222"}</span>
}